import { __module as e } from "../../../_virtual/isISSN.js";
import { a as r } from "./util/assertString.js";
Object.defineProperty(t = e.exports, "__esModule", {
  value: !0
}), t.default = function (e) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  (0, a.default)(e);
  var t = "^\\d{4}-?\\d{3}[\\dX]$";
  if (t = r.require_hyphen ? t.replace("?", "") : t, !(t = r.case_sensitive ? new RegExp(t) : RegExp(t, "i")).test(e)) return !1;
  for (var s = e.replace("-", "").toUpperCase(), o = 0, i = 0; i < s.length; i++) {
    var l = s[i];
    o += ("X" === l ? 10 : +l) * (8 - i);
  }
  return o % 11 == 0;
}, a = r && r.__esModule ? r : {
  default: r
}, e.exports = t.default, e.exports.default = t.default;
var t,
  a,
  s = e.exports;
export { s as i };